import { render, staticRenderFns } from "./sendingemail.vue?vue&type=template&id=803ff0e2&scoped=true&"
import script from "./sendingemail.vue?vue&type=script&lang=js&"
export * from "./sendingemail.vue?vue&type=script&lang=js&"
import style0 from "./sendingemail.vue?vue&type=style&index=0&id=803ff0e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803ff0e2",
  null
  
)

export default component.exports